import React, { FunctionComponent } from "react";
import styles from "../styles/Account.css";
import Body from "./Body";

interface Props {}

const Profile: FunctionComponent<Props> = () => {

    return (
        <div className={styles.bodyContainer} >
            <Body />
        </div>
    )
}

export default Profile;